import { Component, ElementRef, Renderer2, OnInit, OnDestroy, inject, input, output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'datatable-scroller',
  template: ' <ng-content /> ',
  host: {
    class: 'datatable-scroll',
    '[style.height.px]': 'scrollHeight()',
    '[style.width.px]': 'scrollWidth()'
  }
})
export class ScrollerComponent implements OnInit, OnDestroy {
  private readonly renderer = inject(Renderer2);

  readonly scrollbarV = input<boolean>(false);
  readonly scrollbarH = input<boolean>(false);

  readonly scrollHeight = input<number>(undefined);

  readonly scrollWidth = input<number>(undefined);

  readonly scroll = output<unknown>();

  scrollYPos: number = 0;
  scrollXPos: number = 0;
  prevScrollYPos: number = 0;
  prevScrollXPos: number = 0;
  element: HTMLElement;
  parentElement: HTMLElement;
  onScrollListener?: EventListener;

  private _scrollEventListener: ((event: Event) => void) | null = null;

  constructor() {
    const element = inject(ElementRef);

    this.element = element.nativeElement;
  }

  ngOnInit(): void {
    // manual bind so we don't always listen
    if (this.scrollbarV() || this.scrollbarH()) {
      const renderer = this.renderer;
      this.parentElement = renderer.parentNode(renderer.parentNode(this.element));
      this._scrollEventListener = this.onScrolled.bind(this);
      this.parentElement.addEventListener('scroll', this._scrollEventListener);
    }
  }

  ngOnDestroy(): void {
    if (this._scrollEventListener) {
      this.parentElement.removeEventListener('scroll', this._scrollEventListener);
      this._scrollEventListener = null;
    }
  }

  setOffset(offsetY: number): void {
    if (this.parentElement) {
      (this.parentElement as unknown as { scrollTop: number }).scrollTop = offsetY;
    }
  }

  onScrolled(event: Event): void {
    const dom: Element = event.currentTarget as Element;
    requestAnimationFrame(() => {
      this.scrollYPos = dom.scrollTop;
      this.scrollXPos = dom.scrollLeft;
      this.updateOffset();
    });
  }

  updateOffset(): void {
    let direction: string;
    if (this.scrollYPos < this.prevScrollYPos) {
      direction = 'down';
    } else if (this.scrollYPos > this.prevScrollYPos) {
      direction = 'up';
    }

    this.scroll.emit({
      direction,
      scrollYPos: this.scrollYPos,
      scrollXPos: this.scrollXPos
    });

    this.prevScrollYPos = this.scrollYPos;
    this.prevScrollXPos = this.scrollXPos;
  }
}
